import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreLocation } from '../../../../shared/models/storeLocation';
import { State, STATES } from '../../../../shared/models/state';
import { StoreLocationService } from '../../../../shared/services/storelocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationService } from '../../../services/validation.service';

@Component({
  selector: 'app-location-edit-form',
  templateUrl: './location-edit.component.html'
})

export class LocationEditFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() location: StoreLocation; 
  //@Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  editForm : FormGroup; 
  submitted = false;
  public stateList: State[] = STATES;  // bind list of states

  constructor(private formBuilder: FormBuilder, public activeModal: NgbActiveModal, private storeLocationService: StoreLocationService, private notification: MatSnackBar) { }

  // on component load
  ngOnInit() {

    this.editForm = this.formBuilder.group({
      brandId: [this.location.brandId, Validators.required],
      storeId: [this.location.storeId],
      name: [this.location.name, Validators.required],
      address1: [this.location.address1, Validators.required],
      address2: [this.location.address2],
      city: [this.location.city, [Validators.required, ValidationService.alphaNumericSpecialCharactersValidator]],
      state: [this.location.state, Validators.required],
      zipCode: [this.location.zipCode, [Validators.required, ValidationService.zipCodeValidator]],
      email: [this.location.email, Validators.email],
      phone: [this.location.phone, ValidationService.phoneValidator],
      hours: [this.location.hours],
      url: [this.location.url, ValidationService.urlValidator]
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 

      this.storeLocationService.update(this.location.id, this.editForm.value as StoreLocation).subscribe(storeLocation => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The store location ${storeLocation.name} was successuly updated!`, 'Okay!') 
      }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
